import Icon from 'components/shared/Icon'
import React from 'react'

const SearchFilters = ({ pageToggleLeft }) => (
  <div className='ca-filters'>
    <section className='bot-border-black'>
      <h1 className='page-heading'>
        <a href={null} onClick={pageToggleLeft} className='pointer widescreen-hide'>
          <Icon name='icon-close' />
        </a>
        Filters
      </h1>
    </section>
  </div>
)

export default SearchFilters
